import { render, staticRenderFns } from "./DepartmentSetting.vue?vue&type=template&id=924428c6&scoped=true"
import script from "./DepartmentSetting.vue?vue&type=script&lang=js"
export * from "./DepartmentSetting.vue?vue&type=script&lang=js"
import style0 from "./DepartmentSetting.vue?vue&type=style&index=0&id=924428c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924428c6",
  null
  
)

export default component.exports